import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BrowserModule } from '@angular/platform-browser';
import { GlobalErrorHandler } from '../services/GloabalErrorHandler.services';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { NgxEditorModule } from 'ngx-editor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { SharedModule } from '../shared-module/shared-module.module';
import { AngularSplitModule } from 'angular-split';
import { TreeviewModule } from '@soy-andrey-semyonov/ngx-treeview';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { JsonEditorModule } from '../json-editor-module/json-editor.module';

ModuleRegistry.registerModules([
  CsvExportModule
]);



const maskConfig: Partial<IConfig> = {
    validation: false,
  };

@NgModule({
    imports:[
        CommonModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        NgxDatatableModule,
        BrowserAnimationsModule,
        BrowserModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        DragDropModule,
        ClipboardModule,
        TreeviewModule.forRoot(),
        AngularSplitModule,
        TranslateModule,
        JsonEditorModule,
        NgxEditorModule.forRoot({
            locals: {
                bold: 'Negrito',
                italic: 'Itálico',
                code: 'Código',
                blockquote: 'Comentário',
                underline: 'Sublinhado',
                strike: 'Tachado',
                bullet_list: 'Marcadores',
                ordered_list: 'Numeração',
                heading: 'Cabeçalho',
                h1: 'Cabeçalho 1',
                h2: 'Cabeçalho 2',
                h3: 'Cabeçalho 3',
                h4: 'Cabeçalho 4',
                h5: 'Cabeçalho 5',
                h6: 'Cabeçalho 6',
                align_left: 'Alinhar à Esquerda',
                align_center: 'Centralizar',
                align_right: 'Alinhar à Direita',
                align_justify: 'Justificar',
                text_color: 'Cor da Fonte',
                background_color: 'Cor do Fundo',
                url: 'URL',
                text: 'Texto',
                insert: 'Inserir',
                altText: 'Alt Texto',
                title: 'Título',
                remove: 'Remover',
                insertLink: 'Inserir Link',
                removeLink: 'Remover Link',
                insertImage: 'Inserir Imagem'
              
            }}),
        NgxMaskModule.forRoot(maskConfig),
        SharedModule        
    ],
    declarations: [
        
        
      ],
    exports: [
      
    ],
    providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
              subscriptSizing: 'dynamic',
              appearance: 'outline'
            }
          }
    ]
})
export class DynamicFormsModule { 
    
  
}
